import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/organizationFinances', request)
}

export {get}
